<template>
  <div class="box__skeletor">
    <h2 class="skeletor__title"></h2>
    <p class="skeletor__info info1"></p>
    <p class="skeletor__info info2"></p>
    <p class="skeletor__info info3"></p>
    <p class="skeletor__info info4"></p>
    <p class="skeletor__info info5"></p>
    <p class="skeletor__info info6"></p>
  </div>
</template>
<script>
export default {
  name: "LoaderResume"
}
</script>
